import { CreatePromptRequest, Prompt, WorkflowNode } from 'api/model';
import instance from '../axios_instance';

export const getProjectList = async (
  projectId: string,
  includeGlobalPrompts: boolean,
  unusedOnly = false,
): Promise<Prompt[]> => {
  const params = new URLSearchParams();
  if (includeGlobalPrompts) params.set('include_global', 'true');
  if (unusedOnly) params.set('unused_only', 'true');
  const query = params.toString();
  const url = `/projects/${projectId}/prompts${query ? `?${query}` : ''}`;
  const response = await instance.get<Prompt[]>(url);
  return response.data;
};

export const getGlobalList = async (unusedOnly = false): Promise<Prompt[]> => {
  const params = unusedOnly ? '?unused_only=true' : '';
  const response = await instance.get<Prompt[]>(`/prompts${params}`);
  return response.data;
};

export const get = async (id: string, revision?: number): Promise<Prompt> => {
  const url = revision ? `/prompts/${id}/revision/${revision}` : `/prompts/${id}`;
  const response = await instance.get<Prompt>(url);
  return response.data;
};

export const create = async (model: CreatePromptRequest): Promise<Prompt> => {
  const response = await instance.post<Prompt>(`/prompts`, model);
  return response.data;
};

export const update = async (id: string, model: CreatePromptRequest): Promise<Prompt> => {
  const response = await instance.put<Prompt>(`/prompts/${id}`, model);
  return response.data;
};

export const remove = async (id: string) => {
  return await instance.delete(`/prompts/${id}`);
};

export const getNodesUsingPrompt = async (promptId: string) => {
  const response = await instance.get<WorkflowNode[]>(`/prompts/${promptId}/nodes`);
  return response.data;
};

export const getGlobalFolders = async (): Promise<string[]> => {
  const response = await instance.get<string[]>('/prompts/folders');
  return response.data;
};

export const getProjectFolders = async (projectId: string, includeGlobal: boolean): Promise<string[]> => {
  const params = includeGlobal ? '?include_global=true' : '';
  const response = await instance.get<string[]>(`/projects/${projectId}/prompts/folders${params}`);
  return response.data;
};
